const KEY = 'bidmaster_session_replaced';

/** Call when API returns SESSION_REPLACED so the next auth screen can show a message. */
export function setSessionReplacedNotice(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* ignore */
  }
}

/** Returns true once, then clears the flag (use on mount of sign-in / landing). */
export function consumeSessionReplacedNotice(): boolean {
  try {
    if (sessionStorage.getItem(KEY)) {
      sessionStorage.removeItem(KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

export const SESSION_REPLACED_MESSAGE = 'You signed in on another device.';
